// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar_384lN","icon":"sidebar_icon_35woA","active":"sidebar_active_2_BUG"};